import { Avatar, Badge, Box, Group, MantineNumberSize, Text, ThemeIcon } from '@mantine/core'
import { IconBoxOff } from '@tabler/icons'
import { FormattedNumber } from 'react-intl'

interface ProductImage {
  file: string
  title?: string
}

interface ProductType {
  uid: string
  title: string
  subtitle?: string
  description?: string
  image?: ProductImage
  parent?: {
    title: string
  }
  requiresShipping?: boolean
  price?: number
}

interface ProductSummaryProps {
  product?: ProductType
  title?: string
  subtitle?: string
  amount?: number
  price?: number
  picture?: string
  parentTitle?: string
  requiresShipping?: boolean
  avatarSize?: number | 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  avatarRadius?: number | 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  titleSize?: MantineNumberSize
  subtitleSize?: MantineNumberSize
  priceSize?: MantineNumberSize
  titleLineClamp?: number
  subtitleLineClamp?: number
  showSubtitle?: boolean
  showAmount?: boolean
  showPrice?: boolean
  showShippingBadge?: boolean
}

export default function ProductSummary({
  title,
  subtitle,
  amount = 1,
  price = 0,
  picture,
  requiresShipping,
  avatarSize = 'md',
  avatarRadius = 'xl',
  titleSize = 'sm',
  subtitleSize = 'xs',
  priceSize = 'sm',
  titleLineClamp = 2,
  subtitleLineClamp = 2,
  showSubtitle = true,
  showAmount = true,
  showPrice = true,
  showShippingBadge = true
}: ProductSummaryProps) {
  if (!title) return null

  return (
    <Group mb="md" align="flex-start" noWrap>
      <Avatar
        src={picture}
        alt={title}
        radius={avatarRadius}
        size={avatarSize}
        sx={{ flexShrink: 0 }}
      />
      <Box sx={{ flex: 1 }}>
        <Text size={titleSize} lineClamp={titleLineClamp}>
          {title}
        </Text>

        {showSubtitle && subtitle && (
          <Text size={subtitleSize} lineClamp={subtitleLineClamp} mb={4} color="dimmed">
            {subtitle}
          </Text>
        )}
        <Group position="apart">
          <Group position="left" spacing="xs">
            {showAmount && (
              <Text size="xs" color="dimmed">
                {amount} {amount <= 1 ? 'unidade' : 'unidades'}
              </Text>
            )}
            {showShippingBadge && requiresShipping === false && (
              <Badge
                color="teal"
                leftSection={
                  <ThemeIcon color="teal" variant="light" size="xs" display="flex">
                    <IconBoxOff size={18} />
                  </ThemeIcon>
                }>
                Entrega digital
              </Badge>
            )}
          </Group>
          {showPrice && (
            <Text size={priceSize} weight="bold">
              <FormattedNumber style="currency" currency="BRL" value={price} />
            </Text>
          )}
        </Group>
      </Box>
    </Group>
  )
}
